'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('density_compliance', {
      url: '/account/density/density_compliance',
      template: '<density-compliance></density-compliance>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/account/density/density_compliance/density_compliance.routes.js